<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M36 30V36H12V30H8V36C8 38.2 9.8 40 12 40H36C38.2 40 40 38.2 40 36V30H36ZM34 22L31.18 19.18L26 24.34V8H22V24.34L16.82 19.18L14 22L24 32L34 22Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
